import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const Sidebar = () => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();

  let user = null;
  try {
    user = JSON.parse(localStorage.getItem('auth_user'));
  } catch (e) {}
  const navItems = [
    { to: '/admin/dashboard', icon: 'fa-chart-pie', label: 'Dashboard' },
    { to: '/admin/users', icon: 'fa-users', label: 'Users' },
  ];

  const contentItems = [
    { to: '/admin/pages', icon: 'fa-file-lines', label: 'Pages' },
    { to: '/admin/services', icon: 'fa-briefcase', label: 'Services' },
    { to: '/admin/packages', icon: 'fa-tags', label: 'Packages' },
    { to: '/admin/forms', icon: 'fa-table-list', label: 'Custom Forms' },
    { to: '/admin/contacts', icon: 'fa-address-book', label: 'Contacts' },
    { to: '/admin/testimonials', icon: 'fa-comments', label: 'Testimonials' },
    { to: '/admin/blogs', icon: 'fa-blog', label: 'Blogs' },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

        .admin-sidebar {
          width: 260px;
          min-width: 260px;
          height: 100vh;
          background: #061830;
          color: #ffffff;
          display: flex;
          flex-direction: column;
          position: sticky;
          top: 0;
          left: 0;
          border-right: 1px solid rgba(255, 255, 255, 0.15);
          font-family: 'Inter', sans-serif;
          z-index: 100;
          box-shadow: 4px 0 24px rgba(0, 0, 0, 0.15);
          backdrop-filter: blur(12px);
        }

        .admin-sidebar-header {
          padding: 32px 20px 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-bottom: 1px solid rgba(255, 255, 255, 0.15);
        }

        .admin-sidebar-logo-icon {
          width: 40px;
          height: 40px;
          background: rgba(255,255,255,0.1);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 17px;
          color: #CFA047;
          border: 1px solid rgba(207, 160, 71, 0.3);
          flex-shrink: 0;
        }

        .admin-sidebar-brand {
          display: flex;
          flex-direction: column;
        }

        .admin-sidebar-brand-name {
          font-size: 16px;
          font-weight: 800;
          color: #ffffff;
          letter-spacing: -0.4px;
          line-height: 1.2;
        }

        .admin-sidebar-brand-sub {
          font-size: 11px;
          color: rgba(255,255,255,0.6);
          font-weight: 500;
          letter-spacing: 0.4px;
          text-transform: uppercase;
          margin-top: 2px;
        }

        .admin-nav {
          flex: 1;
          padding: 16px 12px;
          display: flex;
          flex-direction: column;
          gap: 2px;
          overflow-y: auto;
        }

        .admin-nav::-webkit-scrollbar {
          width: 6px;
        }
        
        .admin-nav::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.02);
        }
        
        .admin-nav::-webkit-scrollbar-thumb {
          background: #C99F4F;
          border-radius: 10px;
        }

        .admin-nav-section-label {
          font-size: 10px;
          text-transform: uppercase;
          letter-spacing: 1.2px;
          color: rgba(255,255,255,0.4);
          font-weight: 700;
          padding: 10px 10px 4px;
          margin-top: 4px;
        }

        .admin-nav-link {
          padding: 10px 12px;
          color: rgba(255,255,255,0.7);
          text-decoration: none;
          display: flex;
          align-items: center;
          gap: 11px;
          font-weight: 500;
          font-size: 14px;
          border-radius: 10px;
          transition: all 0.18s ease;
          position: relative;
        }

        .admin-nav-link:hover {
          background: rgba(207, 160, 71, 0.15);
          color: #ffffff;
          border: 1px solid rgba(207, 160, 71, 0.3);
          backdrop-filter: blur(8px);
        }

        .admin-nav-link:hover .nav-icon {
          color: #CFA047;
        }

        .admin-nav-link.active {
          background: rgba(207, 160, 71, 0.25);
          color: #ffffff;
          font-weight: 600;
          border: 1px solid rgba(207, 160, 71, 0.5);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          backdrop-filter: blur(10px);
        }

        .admin-nav-link.active .nav-icon {
          color: #CFA047;
        }

        .admin-nav-link.active::before {
          display: none;
        }

        .nav-icon {
          width: 18px;
          text-align: center;
          font-size: 14px;
          color: rgba(255,255,255,0.5);
          transition: color 0.18s;
          flex-shrink: 0;
        }

        .admin-sidebar-divider {
          height: 1px;
          background: rgba(255, 255, 255, 0.15);
          margin: 6px 12px;
        }

        .admin-sidebar-footer {
          padding: 14px 12px 20px;
          border-top: 1px solid rgba(255, 255, 255, 0.15);
        }

        .admin-user-card {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 12px;
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.15);
          margin-bottom: 10px;
          backdrop-filter: blur(4px);
        }

        .admin-user-avatar-sm {
          width: 36px;
          height: 36px;
          border-radius: 10px;
          background: rgba(207, 160, 71, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 14px;
          color: #CFA047;
          border: 1px solid rgba(207, 160, 71, 0.3);
          flex-shrink: 0;
        }

        .admin-user-info { flex: 1; min-width: 0; }

        .admin-user-name {
          font-size: 13px;
          font-weight: 600;
          color: #ffffff;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .admin-user-role {
          font-size: 11px;
          color: rgba(255,255,255,0.6);
          margin-top: 1px;
        }

        .logout-btn {
          width: 100%;
          padding: 10px 14px;
          background: rgba(239, 68, 68, 0.1);
          border: 1px solid rgba(239, 68, 68, 0.2);
          color: #ef4444;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          cursor: pointer;
          transition: all 0.18s ease;
          text-decoration: none;
          font-size: 13px;
          font-weight: 600;
          font-family: 'Inter', sans-serif;
        }

        .logout-btn:hover {
          background: rgba(239, 68, 68, 0.2);
          border-color: rgba(239, 68, 68, 0.3);
        }

        /* Logout Modal */
        .logout-modal-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(15, 23, 42, 0.6);
          backdrop-filter: blur(4px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          animation: fadeIn 0.2s ease-out;
        }

        .logout-modal-content {
          background: white;
          padding: 28px 24px;
          border-radius: 16px;
          width: 320px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.2);
          text-align: center;
          animation: scaleUp 0.2s ease-out;
        }

        .logout-modal-icon {
          width: 56px; height: 56px; border-radius: 50%;
          background: #fee2e2; color: #ef4444;
          display: flex; align-items: center; justify-content: center;
          font-size: 24px; margin: 0 auto 16px;
        }

        .logout-modal-title { font-size: 18px; font-weight: 700; color: #0f172a; margin: 0 0 8px; }
        .logout-modal-desc { font-size: 14px; color: #64748b; margin: 0 0 24px; line-height: 1.5; }
        .logout-modal-actions { display: flex; gap: 12px; }
        .logout-modal-btn {
          flex: 1; padding: 12px; border-radius: 10px; font-weight: 600; cursor: pointer; border: none; transition: all 0.2s; font-size: 14px;
        }
        .logout-modal-btn-cancel { background: #f1f5f9; color: #475569; }
        .logout-modal-btn-cancel:hover { background: #e2e8f0; }
        .logout-modal-btn-confirm { background: #ef4444; color: white; }
        .logout-modal-btn-confirm:hover { background: #dc2626; box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3); }

        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes scaleUp { from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; } }
      `}</style>

      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <img src="/images/logo.png" alt="Logo" style={{ width: '100%', maxWidth: '160px', objectFit: 'contain' }} />
        </div>

        <nav className="admin-nav">
          <div className="admin-nav-section-label">Main Menu</div>
          {navItems.map(({ to, icon, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
            >
              <i className={`fa-solid ${icon} nav-icon`}></i>
              {label}
            </NavLink>
          ))}

          <div className="admin-sidebar-divider"></div>
          <div className="admin-nav-section-label">Content Management</div>
          {contentItems.map(({ to, icon, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
            >
              <i className={`fa-solid ${icon} nav-icon`}></i>
              {label}
            </NavLink>
          ))}

        </nav>

        <div className="admin-sidebar-footer">

          <button onClick={() => setShowLogoutModal(true)} className="logout-btn">
            <i className="fa-solid fa-arrow-right-from-bracket"></i>
            Sign Out
          </button>
        </div>
      </aside>

      {showLogoutModal && (
        <div className="logout-modal-overlay" onClick={() => setShowLogoutModal(false)}>
          <div className="logout-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="logout-modal-icon">
              <i className="fa-solid fa-arrow-right-from-bracket"></i>
            </div>
            <h3 className="logout-modal-title">Sign Out</h3>
            <p className="logout-modal-desc">Are you sure you want to sign out of your admin account?</p>
            <div className="logout-modal-actions">
              <button className="logout-modal-btn logout-modal-btn-cancel" onClick={() => setShowLogoutModal(false)}>
                Cancel
              </button>
              <button 
                className="logout-modal-btn logout-modal-btn-confirm" 
                onClick={() => {
                  localStorage.removeItem('auth_token');
                  localStorage.removeItem('auth_user');
                  navigate('/admin_login');
                }}
              >
                Yes, Sign Out
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
